import UploadItem from "@/shared/models/UploadItem";
import { errorNotification } from "@/shared/utils/Notifications";

export function checkUploadedItems(uploadedItems: UploadItem[]): boolean {
  const uploadingItems = uploadedItems.filter(
    (item: UploadItem) => item.status === "uploading",
  );

  const failedItems = uploadedItems.filter(
    (item: UploadItem) => item.status !== "complete" || !item.uploadedId,
  );

  if (uploadingItems.length > 0) {
    errorNotification(
      "Some items are still uploading:",
      uploadingItems.map((item: UploadItem) => item.name).join(", "),
    );
    return false;
  }

  if (failedItems.length > 0) {
    errorNotification(
      "Some items were not uploaded successfully:",
      failedItems.map((item: UploadItem) => item.name).join(", "),
    );
    return false;
  }

  return true;
}
